import Image from "next/image";
import Link from "next/link";
import { CONTACT, IMG, NAV } from "@/lib/data";

export function Footer() {
  return (
    <footer className="border-t border-line bg-ink px-5 pt-16 pb-8 md:px-8">
      <div className="mx-auto grid max-w-7xl gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Image
            src={IMG.logo}
            alt="STO"
            width={88}
            height={88}
            className="rounded-full object-cover"
          />
          <p className="font-display mt-5 text-5xl tracking-[0.12em] md:text-7xl">STO</p>
          <p className="mt-3 text-sm text-mute">
            Société de Tir d’Ostwald · Association · FFTir
            <br />
            Quai Olida, zone omnisports · 67540 Ostwald
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] tracking-[0.28em] text-brass uppercase">Navigation</p>
          <ul className="mt-4 space-y-2 text-sm">
            {NAV.map((item) => (
              <li key={item.href}>
                <Link href={item.href} className="opacity-70 transition hover:text-brass hover:opacity-100">
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <Link href="/infos" className="opacity-70 transition hover:text-brass hover:opacity-100">
                Horaires
              </Link>
            </li>
            <li>
              <Link href="/actualites" className="opacity-70 transition hover:text-brass hover:opacity-100">
                Actualités
              </Link>
            </li>
            <li>
              <Link href="/partenaires" className="opacity-70 transition hover:text-brass hover:opacity-100">
                Partenaires
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[10px] tracking-[0.28em] text-brass uppercase">Contact</p>
          <p className="mt-4 text-sm opacity-80">
            <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
            <br />
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
          </p>
          <a
            href={CONTACT.shop}
            className="mt-6 inline-block text-xs tracking-[0.16em] text-brass uppercase"
            target="_blank"
            rel="noreferrer"
          >
            Boutique club →
          </a>
        </div>
      </div>
      <div className="mx-auto mt-16 flex max-w-7xl flex-col justify-between gap-3 border-t border-line pt-6 font-mono text-[10px] tracking-widest text-mute uppercase md:flex-row">
        <span>© {new Date().getFullYear()} STO · Safe & protect</span>
        <span>10 · 20 · 25 · 50 m</span>
      </div>
    </footer>
  );
}
